import React from 'react';
import { ReactComponent as Clock } from '../../assets/images/icons/clockCheck.svg';

export default function ClockCheckIcon(props) {
  return (
    <Clock className={`icon ${props.className}`} />
  );
}
